import React, {Fragment} from 'react';
import {default as SelectControl, createFilter} from 'react-select';
import CreatableSelect from 'react-select/lib/Creatable';
import {sendRequest} from '../../utils/request.js';
import isEqual from 'lodash-es/isEqual';
import config from "../../config/config";
import axios from "axios";
import PropTypes from "prop-types";
import classNames from 'classnames';
import {getComponentConfig} from "../../utils/components";
import {get, set} from "../../utils/dotutils";

function removeDuplicates(myArr, prop) {
    return myArr.filter((obj, pos, arr) => {
        return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
    });
}

const lastRequests = {};

class Select extends React.Component {

    static propTypes = {
        storeType: PropTypes.oneOf(["local", "remote", "bound"]),
        saveChanges: PropTypes.func,
        onSelect: PropTypes.func,
        valueKey: PropTypes.string,
        labelKey: PropTypes.string,
        optionsTemplate: PropTypes.func,
        selectedOptionTemplate: PropTypes.func,
        disabledKey: PropTypes.string,
        matchmode: PropTypes.string,
        searchtype: PropTypes.string,
        component: PropTypes.string,
        listfield: PropTypes.string,
        optionname: PropTypes.string,
        optioncomponent: PropTypes.string,
        isLoading: PropTypes.bool,
        placeholder: PropTypes.string,
        isSearchable: PropTypes.bool,
        isCreatAble: PropTypes.bool,
        isClearable: PropTypes.bool,
        isMulti: PropTypes.bool,
        minLength: PropTypes.number,
        options: PropTypes.array,
        limit: PropTypes.number,
        boundValue: PropTypes.any,
        boundField: PropTypes.any,
        filter: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        order: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        groupBy: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        parameters: PropTypes.object,
        value: PropTypes.any,
        label: PropTypes.any,
        required: PropTypes.bool,
        disabled: PropTypes.any,
        readOnly: PropTypes.any,
        error: PropTypes.any,
        name: PropTypes.string,
        createOptionPosition: PropTypes.oneOf(["first", "last"]),
        formatCreateLabel: PropTypes.func,
        autoSelect: PropTypes.bool,
        objectValue: PropTypes.bool,
        isOptionDisabled: PropTypes.func,
        view: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
        onLoadCompleted: PropTypes.func,
        onInputValueChanged: PropTypes.func,
        className: PropTypes.any,
        openIfHasOptions: PropTypes.bool,
        searchFormatter: PropTypes.any,
    };

    state = {
        isLoading: false,
        optionIsLoading: false,
        options: [],
        usedoptions: [],
        search: '',
        isFocused: false
    };

    componentDidMount() {
        this.componentDidUpdate({}, {}, {});
    }

    componentDidUpdate(prevProps, prevState, prevContext) {
        const renew = () => {
            const current = this.generateQueryParams(this.props, this.state);
            const prev = this.generateQueryParams(prevProps, prevState);
            if (!isEqual(current, prev) || !isEqual(this.props.value, prevProps.value) || !isEqual(this.state.labelKey, prevState.labelKey) || !isEqual(this.state.valueKey, prevState.valueKey)) {
                this.setState({
                    labelKey: current.labelKey,
                    valueKey: current.valueKey,
                }, () => {
                    if (this.queryTimeout !== undefined) {
                        clearTimeout(this.queryTimeout);
                    }
                    this.queryTimeout = setTimeout(() => {
                        this.loadOptions();
                    }, 300);
                });
            }
        }
        if (this.props.component !== prevProps.component) {
            getComponentConfig(this.props.component).then((componentConfig) => {
                if (componentConfig.target) {
                    getComponentConfig(componentConfig.target).then((targetConfig) => {
                        componentConfig.targetConfig = targetConfig;
                        this.setState({
                            componentConfig
                        }, renew);
                    });
                } else {
                    this.setState({
                        componentConfig
                    }, renew);
                }
            })
        } else {
            renew();
        }
    }

    componentWillUnmount() {
        //this.lastrequest && this.lastrequest.abort();
        //this.lastOptionRequest && this.lastOptionRequest.abort();
    }

    emptyMessage = () => {
        if(this.state.isLoading) {
            return "Keresés...";
        }
        return this.props.storeType !== "remote" || this.state.search.length >= (this.props.minLength || config.minimumLengthOfSearch) ? "Nincs találat" : "Legalább 3 karaktert írj be a kereséshez!";
    }

    handleInputChange = (q) => {
        if (!(this.state.search.length === 1 && q.length === 0)) {
            q = q || this.state.search;
        }
        if (q !== this.state.search) {
            this.setState({
                search: q
            }, () => {
                if (this.props.onInputValueChanged) {
                    this.props.onInputValueChanged(q);
                }
            });
        }
    }

    generateQueryParams = (props, state) => {
        let valueKey = props.valueKey || (props.optionname ? 'optionid' : 'id');
        let labelKey = props.labelKey || (props.optionname ? 'optionlabel' : 'label');
        const listparams = {
            option: "componentlist",
            matchmode: props.matchmode || "any",
            searchtype: props.searchtype || null,
            component: props.component || "option",
            group: props.groupBy,
            order: props.order,
            itemsperpage: props.storeType && props.storeType === "local" ? 0 : props.limit || 30,
        };
        if (props.listfield) {
            listparams.listfield = props.listfield;
        }
        if (props.optioncomponent) {
            listparams.optioncomponent = props.optioncomponent;
        }
        if (props.storeType === "local") {

        } else if (props.storeType && props.storeType === "bound" && props.boundValue) {
            if (props.boundValue) {
                listparams.filter = [{field: props.boundField, value: props.boundValue}];
            }
        } else {
            if (state.search) {
                let search = state.search;
                if (props.searchFormatter) {
                    if (Array.isArray(props.searchFormatter)) {
                        let i = 0;
                        for (;i < props.searchFormatter.length;i++) {
                            if (props.searchFormatter[i] instanceof Function) {
                                search = props.searchFormatter[i](search);
                            } else {
                                search = props.searchFormatter[i];
                            }
                        }
                    } else if (props.searchFormatter instanceof Function) {
                        search = props.searchFormatter(search);
                    }
                }
                if (search) {
                    search = search + "";
                }
                if (search && search.length >= (props.minLength || config.minimumLengthOfSearch)) {
                    listparams.search = search.trim();
                } else {
                    return false;
                }
            }
        }
        if (!props.component) {
            listparams.optionname = props.optionname;
        } else {
            const componentConfig = state.componentConfig;
            if (!componentConfig) {
                return false;
            }
            if (!props.labelKey) {
                // TODO adapter fielddefs
                if (componentConfig.namefield) {
                    labelKey = componentConfig.namefield;
                } else if ((componentConfig.fielddefs || {}).name) {
                    labelKey = "name";
                } else if ((componentConfig.fielddefs || {}).title) {
                    labelKey = "title";
                } else if ((componentConfig.fielddefs || {}).label) {
                    labelKey = "label";
                    // decorator config field
                } else if (componentConfig.targetConfig) {
                    if (componentConfig.targetConfig.namefield) {
                        labelKey = componentConfig.targetConfig.namefield;
                    } else if ((componentConfig.targetConfig.fielddefs || {}).name) {
                        labelKey = "name";
                    } else if ((componentConfig.targetConfig.fielddefs || {}).title) {
                        labelKey = "title";
                    } else if ((componentConfig.targetConfig.fielddefs || {}).label) {
                        labelKey = "label";
                    }
                }
            }
            if (!props.valueKey) {
                valueKey = componentConfig.idfield;
            }
        }
        let filter = listparams.filter;
        if (filter && !Array.isArray(filter)) filter = [filter];
        if (props.filter) {
            filter = [...(filter || []), ...(Array.isArray(props.filter) ? props.filter : [props.filter])];
        }
        if (props.parameters) {
            listparams.parameters = props.parameters;
        }
        if (filter) {
            listparams.filter = filter;
        } else {
            delete listparams.filter;
        }
        if (props.view) {
            listparams.view = props.view;
        }

        // TODO undefined view to default!!!

        if (this.props.optionsTemplate) {
            const template = this.props.optionsTemplate;
            if (template instanceof Object) {
                let templateView = template.view || [];
                if (Array.isArray(listparams.view)) {
                    if (Array.isArray(templateView)) {
                        listparams.view = [...listparams.view, ...templateView];
                    } else if (templateView instanceof Object) {
                        const view = listparams.view;
                        listparams.view = {};
                        view.map((v) => listparams.view[v] = "");
                        listparams.view = {...listparams.view, ...templateView};
                    } else {
                        console.error(`Select view not compatible with option template view! ${listparams.view} - ${templateView}`);
                    }
                } else if (listparams.view instanceof Object) {
                    if (Array.isArray(templateView)) {
                        const view = templateView;
                        templateView = {};
                        view.map((v) => templateView[v] = "");
                        listparams.view = {...listparams.view, ...templateView};
                    } else if (templateView instanceof Object) {
                        listparams.view = [...listparams.view, ...templateView];
                    } else {
                        console.error(`Select view not compatible with option template view! ${listparams.view} - ${templateView}`);
                    }
                } else if (!listparams.view && templateView) {
                    listparams.view = templateView;
                } else if (!!listparams.view && !templateView) {
                    // nothing to do
                } else {
                    console.error(`Select view not compatible with option template view! ${listparams.view} - ${templateView}`);
                }
            }
        }

        if (this.props.selectedOptionTemplate) {
            const template = this.props.selectedOptionTemplate;
            if (template instanceof Object) {
                let templateView = template.view || [];
                if (Array.isArray(listparams.view)) {
                    if (Array.isArray(templateView)) {
                        listparams.view = [...listparams.view, ...templateView];
                    } else if (templateView instanceof Object) {
                        const view = listparams.view;
                        listparams.view = {};
                        view.map((v) => listparams.view[v] = "");
                        listparams.view = {...listparams.view, ...templateView};
                    } else {
                        console.error(`Select view not compatible with option template view! ${listparams.view} - ${templateView}`);
                    }
                } else if (listparams.view instanceof Object) {
                    if (Array.isArray(templateView)) {
                        const view = templateView;
                        templateView = {};
                        view.map((v) => templateView[v] = "");
                        listparams.view = {...listparams.view, ...templateView};
                    } else if (templateView instanceof Object) {
                        listparams.view = [...listparams.view, ...templateView];
                    } else {
                        console.error(`Select view not compatible with option template view! ${listparams.view} - ${templateView}`);
                    }
                } else if (!listparams.view && templateView) {
                    listparams.view = templateView;
                } else if (!!listparams.view && !templateView) {
                    // nothing to do
                } else {
                    console.error(`Select view not compatible with option template view! ${listparams.view} - ${templateView}`);
                }
            }
        }

        if (Array.isArray(listparams.view)) {
            if (listparams.view.indexOf(valueKey) === -1) {
                listparams.view.push(valueKey);
            }
            if (listparams.view.indexOf(labelKey) === -1) {
                listparams.view.push(labelKey);
            }
            const listview = listparams.view;
            listparams.view = {};
            listview.map((field) => {
                set(listparams.view, field, "");
            });
        } else if (listparams.view instanceof Object) {
            if (!listparams.view[valueKey]) {
                set(listparams.view, valueKey, get(listparams.view, valueKey) || "");
            }
            if (!listparams.view[labelKey]) {
                set(listparams.view, labelKey, get(listparams.view, labelKey) || "");
            }
        } else if(props.objectValue === false) {
            listparams.view = {};
            set(listparams.view, valueKey, "");
            set(listparams.view, labelKey, "");
        } else {
            listparams.view = listparams.view || [valueKey,labelKey];
            if (Array.isArray(listparams.view)) {
                const listview = listparams.view;
                listparams.view = {};
                listview.map((field) => {
                    set(listparams.view, field, "");
                });
            }
        }
        listparams.labelKey = labelKey;
        listparams.valueKey = valueKey;
        return listparams;
    }

    promisedSetState = (newState) => {
        return new Promise((resolve) => {
            this.setState(newState, () => {
                resolve()
            });
        });
    }

    loadOptions = async () => {
        this.lastOptionRequest && this.lastOptionRequest.abort();
        const onLoadCompleted = (options, search) => {
            if (this.props.onLoadCompleted) {
                let newOptions = this.props.onLoadCompleted(options, search);
                if (Array.isArray(newOptions)) {
                    return newOptions;
                }
            }
            return options;
        }
        this.lastrequest && this.lastrequest.abort();
        this.setState({isLoading: true, optionIsLoading: true}, async () => {
            if (this.props.storeType !== "local") {
                const listparams = await this.generateQueryParams(this.props, this.state);
                if (!listparams) {
                    await this.promisedSetState({optionIsLoading: false});
                } else {
                    delete listparams.search;
                    delete listparams.filter;
                    const props = this.props;
                    const valueKey = listparams.valueKey;
                    let value = props.value;

                    if (props.isMulti) {
                        if (!Array.isArray(value)) {
                            if (value) {
                                value = [value];
                            } else {
                                value = [];
                            }
                        }
                        if (value.length) {
                            if ((props.objectValue === undefined || props.objectValue === true) && typeof (value[0]) !== "object") {
                                const values = [...(props.options || this.state.options), ...this.state.usedoptions];
                                if (values.length > 0) {
                                    value = removeDuplicates(values, valueKey).filter((option) => value.indexOf(option[valueKey]) !== -1).map((option) => option[valueKey]);
                                }
                            } else if (typeof (value[0]) === "object") {
                                value = value.map((v) => v[valueKey]);
                            }
                        }
                    } else {
                        if ((props.objectValue === undefined || props.objectValue === true) && typeof (value) !== "object") {
                            const values = [...(props.options || this.state.options), ...this.state.usedoptions];
                            if (values.length > 0) {
                                value = (removeDuplicates(values, valueKey).find((option) => option[valueKey] == value) || {});
                            }
                        }
                        value = typeof (value) === 'object' && value !== null && value !== undefined ? (value[valueKey] || null) : (value !== null && value !== undefined ? (value || null) : null);
                    }

                    if (Array.isArray(value)) {
                        if (value && value.length) {
                            listparams.filter = [{field: valueKey, value: value, operator: "in"}];
                        }
                    } else {
                        if (value) {
                            listparams.filter = [{field: valueKey, value: value}];
                        }
                    }

                    if (listparams.filter) {
                        if (lastRequests[JSON.stringify(listparams)]) {
                            this.lastOptionRequest = lastRequests[JSON.stringify(listparams)];
                        } else {
                            lastRequests[JSON.stringify(listparams)] = this.lastOptionRequest = sendRequest(listparams);
                        }
                        this.lastOptionRequest.then((data) => {
                            this.setState({labelKey: listparams.labelKey, valueKey: listparams.valueKey, optionIsLoading: false, usedoptions: [...(data.items || [])]});
                        }).catch((e) => {
                            if (!(e instanceof axios.Cancel) && e.message) {
                                console.log(e);
                                this.setState({labelKey: listparams.labelKey, valueKey: listparams.valueKey, optionIsLoading: false});
                            }
                        });
                    } else {
                        this.setState({labelKey: listparams.labelKey, valueKey: listparams.valueKey, optionIsLoading: false});
                    }
                }
            } else {
                await this.promisedSetState({optionIsLoading: false});
            }
            if (this.props.storeType === "local" || (this.props.storeType === "bound" && this.props.boundValue) || this.state.search) {
                if (!this.props.options) {
                    const reqparams = await this.generateQueryParams(this.props, this.state);
                    if (!reqparams) {
                        await this.promisedSetState({isLoading: false});
                        return;
                    }
                    if (lastRequests[JSON.stringify(reqparams)]) {
                        this.lastrequest = lastRequests[JSON.stringify(reqparams)];
                    } else {
                        lastRequests[JSON.stringify(reqparams)] = this.lastrequest = sendRequest(reqparams);
                    }
                    this.lastrequest.then((data) => {
                        delete lastRequests[JSON.stringify(reqparams)];
                        let items = onLoadCompleted(data.items || [], reqparams.search);
                        // TODO ezt azért majd ha az option language stb össze van rakva ki kéne venni
                        if (reqparams.optionname) {
                            items = removeDuplicates(items, "optionid");
                        }
                        this.setState({labelKey: reqparams.labelKey, valueKey: reqparams.valueKey, isLoading: false, options: items}, () => {
                            if (data.items.length === 1 && (this.props.storeType === "bound" || this.props.autoSelect)) {
                                this.handleChange(items[0]);
                            }
                        });
                    }).catch((e) => {
                        delete lastRequests[JSON.stringify(reqparams)];
                        if (!(e instanceof axios.Cancel) && e.message) {
                            console.log(e);
                            this.setState({labelKey: reqparams.labelKey, valueKey: reqparams.valueKey, isLoading: false, options: []});
                        }
                    });
                } else {
                    await this.promisedSetState({isLoading: false, options: []});
                    if (this.props.options.length === 1 && (this.props.storeType === "bound" || this.props.autoSelect)) {
                        this.handleChange(this.props.options[0]);
                    }
                }
            } else {
                await this.promisedSetState({isLoading: false, options: []});
            }
        });
    }

    handleChange = async (selected) => {
        let value = await this.returnValueParser(selected);
        if (this.props.onSelect) {
            this.props.onSelect(value);
        }
        if (this.props.saveChanges) {
            this.props.saveChanges(this.props.name, value);
        }
        this.setState({
            search: ''
        });
    }

    returnValueParser = async (value) => {
        const valueKey = this.props.valueKey || this.state.valueKey;
        if (this.props.isMulti) {
            if (!Array.isArray(value)) {
                if (value) {
                    value = [value];
                } else {
                    value = [];
                }
            }
            if (value.length) {
                if ((this.props.objectValue === undefined || this.props.objectValue === true) && typeof (value[0]) !== "object") {
                    value = removeDuplicates([...(this.props.options || this.state.options), ...this.state.usedoptions], valueKey).filter((option) => value.indexOf(option[valueKey]) !== -1);
                } else if (this.props.objectValue === false && typeof (value[0]) === "object") {
                    value = value.map((v) => v[valueKey]);
                }
            }
        } else {
            if ((this.props.objectValue === undefined || this.props.objectValue === true) && typeof (value) !== "object") {
                value = removeDuplicates([...(this.props.options || this.state.options), ...this.state.usedoptions], valueKey).find((option) => option[valueKey] == value);
            } else if(this.props.objectValue === false && typeof (value) === "object") {
                if (value !== null && value !== undefined) {
                    value = value[valueKey];
                } else {
                    value = null;
                }
            }
        }
        return value;
    }

    optionValueParser = () => {
        let value = this.props.value;
        const valueKey = this.props.valueKey || this.state.valueKey;
        if (this.props.isMulti) {
            if (!Array.isArray(value)) {
                if (value) {
                    value = [value];
                } else {
                    value = [];
                }
            }
            if (value.length) {
                if (typeof (value[0]) !== "object") {
                    value = removeDuplicates([...(this.props.options || this.state.options), ...this.state.usedoptions], valueKey).filter((option) => value.find((v) => v + "" === "" + option[valueKey]));
                }
            }
            return value === undefined ? (this.props.isCreatAble ? this.props.value : []) : value;
        } else {
            if ( ! (value instanceof Object)) {
                value = removeDuplicates([...(this.props.options || this.state.options), ...this.state.usedoptions], valueKey).find((option) => option[valueKey] + "" === "" + value);
            } else if(value instanceof Object && value[valueKey] !== undefined) {
                value = removeDuplicates([...(this.props.options || this.state.options), ...this.state.usedoptions], valueKey).find((option) => option[valueKey] + "" === "" + value[valueKey]);
            }
            return value === undefined ? (this.props.isCreatAble ? this.props.value : null) : value;
        }
    }

    focus = () => {
        this.el.focus();
    }

    render() {
        const valueKey = this.props.valueKey || this.state.valueKey;
        const labelKey = this.props.labelKey || this.state.labelKey;
        let value = this.optionValueParser();
        /*if (Array.isArray(value)) {
            value = value.map((v) => v !== null && v !== undefined && typeof v === "object" ? v[valueKey] : v);
        } else if (value !== null && value !== undefined && typeof value === "object") {
            value = value[valueKey];
        }*/
        let options = this.props.options || this.state.options;
        const classNamePrefix = "react-select";
        const props = {
            classNamePrefix: classNamePrefix,
            className: classNames(classNamePrefix, this.props.className, {"is-invalid": this.props.error}),
            isMulti: this.props.isMulti || false,
            onChange: this.handleChange,
            isDisabled: !!(this.props.disabled || false),
            noOptionsMessage: this.emptyMessage,
            placeholder: this.props.placeholder || "",
            isClearable: this.props.isLoading || this.state.isLoading || this.state.optionIsLoading ? false : (this.props.isClearable || false),
            allowCreateWhileLoading: false,
            onFocus: () => {
                this.setState({
                    isFocused: true
                })
            },
            onBlur: () => {
                const state = {
                    isFocused: false
                };
                if (!this.props.isCreatAble) {
                    state.search = '';
                }
                this.setState(state);
            },
            formatCreateLabel: this.props.formatCreateLabel || ((inputValue) => (inputValue || '').trim()),
            getNewOptionData: (inputValue, optionLabel) => {
                const option = {};
                set(option, valueKey, null);
                set(option, labelKey, optionLabel);
                return option;
            },
            name: this.props.name,
            value: value,
            getOptionValue: (option) => get(option, valueKey, undefined),
            getOptionLabel: (option) => get(option, labelKey, undefined),
            formatOptionLabel: (option, meta) => {
                if (meta.context === "menu") {
                    if (this.props.optionsTemplate) {
                        const Template = this.props.optionsTemplate;
                        return <Template {...option} valueKey={valueKey} labelKey={labelKey} />;
                    }
                } else if (meta.context === "value") {
                    if (this.props.selectedOptionTemplate) {
                        const Template = this.props.selectedOptionTemplate;
                        return <Template {...option} valueKey={valueKey} labelKey={labelKey} />;
                    }
                }
                if (labelKey === undefined) {
                    return null;
                }
                return get(option, labelKey, undefined);
            },
            createOptionPosition: this.props.createOptionPosition || "first",
            //onInputChange: (inputValue) => this.handleChange(inputValue),
            autoFocus: this.props.autoFocus || false,
            inputValue: this.state.search,
            isOptionDisabled: (option) => option && typeof option === "object" && option[this.props.disabledKey || "disabled"],
            filterOption: this.props.storeType === "remote" ? () => {
                return true;
            } : createFilter({ignoreAccents: false, matchFrom: this.props.matchmode || 'any', ignoreCase: true})
        };
        props.styles = {
            multiValueRemove: (base, state) => {
                return props.isDisabled ? { ...base, pointerEvents: 'none' } : base;
            }
        };

        if (this.props.openIfHasOptions === true) {
            if ((this.props.options || this.state.options).length > 0 && this.state.isFocused) {
                props.menuIsOpen = true;
            } else {
                props.menuIsOpen = false;
            }
        }
        props.menuIsOpen = this.props.menuIsOpen !== undefined ? this.props.menuIsOpen : props.menuIsOpen;

        if (this.props.isCreatAble) {
            props.promptTextCreator = (label) => {
                return "Új érték mentése: " + label;
            };
        }
        const SelectComponent = this.props.isCreatAble ? CreatableSelect : SelectControl;
        props.isLoading = this.props.isLoading || this.state.isLoading || this.state.optionIsLoading;
        props.isSearchable = this.props.isSearchable !== undefined && this.props.isSearchable !== null ? this.props.isSearchable : true;
        //props.isSearchable = true;
        props.options = options;
        props.onInputChange = this.handleInputChange;
        props.loadingMessage = () => "Keresés...";
        props.menuPlacement = "auto";

        let style = {};
        if (this.props.label === false) {
            style.display = "none";
        }

        return <Fragment>
            <label htmlFor={this.props.name} className="control-label" style={style}>{this.props.label} {this.props.required && <span className="invalid-feedback">*</span>}</label>
            <SelectComponent ref={(el) => this.el = el} {...props} inputId={this.props.name} />
            {this.props.error && <div className="invalid-feedback">{this.props.error}</div>}
        </Fragment>;
    }

}

export default Select;